var mp = mp || {};

// FancyBox
//-----------------------------------------------------------------
mp.fancyBox = function() {
    var $trigger = $("[data-fancybox]");

    if (!$trigger.length) {
        return;
    }

    $.fancybox.defaults.touch = false;
    $.fancybox.defaults.hash = false;
    
    $trigger.fancybox({
        hideScrollbar: true,
    });
};


// Background image holder
//-----------------------------------------------------------------
mp.backgroundHolder = function() {
    var $element = $(".background-holder");

    if (!$element.length) {
        return;
    }

    $element.each(function(){
        var $img = $(this).find('img');
        var $imageSrc = $img.attr('src');
        $img.remove();
        $(this).css('background-image', 'url('+$imageSrc+')');
    });
};


// Sticky menu
//-----------------------------------------------------------------
mp.stickyMenu = function () {

    var $element = $('.header');

    setSticky();

    $(window).scroll(function(){
        setSticky();
    });

    function setSticky() {
        if ($(window).scrollTop() > 50) {
            $element.addClass('scrolled');
        } else {
            $element.removeClass("scrolled");
        }
    }
}



// Sticky sidebar
//-----------------------------------------------------------------
mp.stickySidebar = function () {

    var $element = $('.sticky');

    if (!$element.length) {
        return;
    }

    $element.stickySidebar({
        containerSelector: '.sticky--container',
        topSpacing: 110,
        bottomSpacing: 0,
        minWidth: 1023,
    });
}


// Animate on Scroll
//-----------------------------------------------------------------
mp.animateOnScroll = function () {
    var $element = $('.animated');

    if (!$element.length) {
        return;
    }

    animateDiv();

    $(window).scroll(function() {
        animateDiv();
    });

    function animateDiv() {
        var $topOfWindow = $(window).scrollTop();

        $element.each(function(){
            var $animationType = $(this).data("animation");
            var $contentPos = $(this).offset().top;

            if ($contentPos < $topOfWindow+600) {
                $(this).addClass($animationType).removeClass("animated");
            }
        });
    }
}


// Scroll to element
//-----------------------------------------------------------------
mp.scrollToElement = function () {
    var $element = $('.scrollTo');

    if (!$element.length) {
        return;
    }
    
    $element.on('touchstart, click', function(e){
        e.preventDefault();
        var $dataURL = $(this).attr('href');

        scrollContent($dataURL);
    })
    
    function scrollContent($dataURL){
        $.scrollTo($dataURL, 1200, {
            axis: 'y',
            offset: -80,
        });
    }
}


// Parallax
//-----------------------------------------------------------------
mp.parallax = function () {
    var $element = $('.parallax');

    if (!$element.length) {
        return;
    }
    
    $element.parallaxBackground({
        parallaxSpeed: '0.2'
    });
}


// Masonry
//-----------------------------------------------------------------
mp.masonryGrid = function () {
    var $element = $('.masonry--grid');

    if (!$element.length) {
        return;
    }
    
    var $grid = $('.masonry--grid').masonry({
        itemSelector: '.masonry--grid-item',
    });

    $grid.imagesLoaded().progress( function() {
        $grid.masonry('layout');
    });
}



$(document).ready(function (){
    mp.fancyBox();
    mp.backgroundHolder();
    mp.stickyMenu();
    mp.stickySidebar();
    mp.animateOnScroll();
    mp.scrollToElement();
    mp.parallax();
    mp.masonryGrid();
});